export function getModelPreviewStyle(model, containerWidth = 280, { maxScale = Infinity, containerHeight = null } = {}) {
    const canvasSize = model?.canvasSize || { width: 1080, height: 1080 };
    const safeWidth = Math.max(1, containerWidth || 1);
    let scale = Math.min(maxScale, Math.max(0.05, safeWidth / canvasSize.width));
    if (containerHeight && containerHeight > 0) {
        const scaleByHeight = Math.min(maxScale, Math.max(0.05, containerHeight / canvasSize.height));
        scale = Math.min(scale, scaleByHeight);
    }
    return { canvasSize, scale, width: canvasSize.width * scale, height: canvasSize.height * scale };
}

export function resolveAuthorName(autor) {
    if (!autor) return "Auteur inconnu";
    if (typeof autor === "string") return autor;
    const fullName = [autor.nom, autor.prenoms].filter(Boolean).join(" ").trim();
    return fullName || autor.mail || "Auteur inconnu";
}
